import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=184b58d6&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports